import React from "react";
import { ScheduleView } from "@components";

const SchedulePage: React.FC = () => {
  return (
    <ScheduleView contentDisplayed="reservations" />
  );
};

export default SchedulePage;